import React from 'react';
import {
    Grid,
    CircularProgress,
    Typography,
    Theme
} from '@material-ui/core';
import { StyleRules, createStyles, withStyles } from '@material-ui/core/styles';

interface SpinnerProps {
    classes?: any;
}

const styles = (theme: Theme): StyleRules => {
    return createStyles({
        loadingWrapper: {
            minHeight: '150px',
            height: '100%',
            textAlign: 'center'
        },
        loadingText: {
            fontSize: '10px',
            fontWeight: 'lighter',
            color: theme.palette.text.primary
        }
    });
};

const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps): JSX.Element => {
    return (
        <Grid container alignItems='center' alignContent='center' className={props.classes.loadingWrapper}>
            <Grid item xs={12}>
                <CircularProgress thickness={5} disableShrink />
            </Grid>
            <Grid item xs={12}>
                <Typography variant='caption' className={props.classes.loadingText}>LOADING</Typography>
            </Grid>
        </Grid>
    );
};

export default withStyles(styles)(Spinner);
